import { createSlice } from '@reduxjs/toolkit'

import { RootState } from '../../store/store'
import { editorInitialState } from './definitions'

export const editorSlice = createSlice({
  name: 'editor',
  initialState: editorInitialState,
  reducers: {
    activateEditor: (state) => {
      state.value = true
    },
    disableEditor: (state) => {
      state.value = false
    },
  },
})

export const { activateEditor, disableEditor } = editorSlice.actions
export const selectEditorMode = (state: RootState): boolean =>
  state.editor.value
export default editorSlice.reducer
